import React, { useState, useContext, SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

//MUI
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

//Custom
import OperationsContext from "@/components/OperationsContext/OperationsContext";

//Types
import { PickerItem } from "@/@types/controls/controls";
import { AutocompleteChangeReason } from "@mui/material";
import { OperationsContextType } from "@/components/OperationsContext/OperationsContext";

export type ObjectPickerProps = {
  items: Array<PickerItem>;
  selectedItem: PickerItem | null;
  onChange: (id: number | null) => void;
};

const ObjectPicker = (props: ObjectPickerProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const { items, selectedItem, onChange } = props;

  const label = "operations.select_object";
  const loadingText = "operations.loading";

  const handleChange = (
    evt: SyntheticEvent,
    value: PickerItem | null,
    reason: AutocompleteChangeReason
  ) => {
    switch (reason) {
      case "createOption":
        break;
      case "selectOption":
        applyChange(value);
        break;
      case "removeOption":
        break;
      case "clear":
        applyChange(null);
        break;
      case "blur":
        break;
    }
  };

  const applyChange = (option: PickerItem | null) => {
    if (option) {
      onChange(option.value as number);
    } else {
      onChange(null);
    }
  };

  return (
    <Autocomplete
      disablePortal
      size="small"
      options={items}
      value={selectedItem}
      getOptionLabel={(option: PickerItem) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            placeholder={t(label)}
            variant="outlined"
            required={false}
            label={undefined}
            sx={{ ml: 2, width: 200 }}
          />
        );
      }}
      autoSelect={true}
      onChange={handleChange}
      loading={isLoading}
      loadingText={t(loadingText)}
      autoHighlight
    />
  );
};

export default ObjectPicker;
